<template>
  <div class="newsList">
    <div class="mainbg">
      <sec-carousel></sec-carousel>
    </div>
    <div class="mainbgTwo"><img src="../assets/images/news/mainbgTwo.jpg" alt=""></div>
    <div class="container">
        <div class="row rowwarp">
            <div class="rowwpLeft">
                <div class="navList">
                    <div class="navtop">
                        <img src="../assets/images/news/sidebar_title.jpg" alt="">
                        <div class="nav-mes1">{{firMenu.Memo}}</div>
                        <div class="nav-mes2">{{firMenu.Name}}</div>
                    </div>
                    <div class="tab">
                        <div class="btnTab">
                            <span v-for="(item,index) in subMenu" :class="item.Name == curMenu.Name ?'active spanList':'spanList'" @click="getBtn(item,index)">{{item.Name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rowwpRight">
                <div class="itemtop">
                    <img src="../assets/images/news/brnav_home.png" alt="">
                    <span><a href="javascript:void(0);" @click="returnBack">  首页</a></span>
                    <span>&gt;</span>
                    <span><a href="#">{{fname}}</a></span>
                    <span>&gt;</span>
                    <span><a href="#">{{curMenu.Name}}</a></span>
                </div>
                <div class="rowwpLeft2">
                    <div class="navList2">
                        <div class="navtop2">
                            <img src="../assets/images/news/sidebar_titleTwo.jpg" alt="">
                            <div class="nav-mes2">{{fname}}</div>
                        </div>
                        <div class="tab2">
                            <div class="tab2Img">
                                <img src="../assets/images/news/rowleft.png"/>
                            </div>
                            <ul class="btnTabTwo">
                              <li v-for="(items,index) in subMenu" :class="items.Name == curMenu.Name ?'activeTwo spanListTwo':'spanListTwo'" @click="getBtn(items)" >{{items.Name}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="box" v-show="$route.params.key !== 'development' && $route.params.key !== 'responsibility' && $route.params.key !== 'NewsVideo'">
                    <div class="content">
                        <div class="liebiao" v-loading="loading">
                            <ul>
                                <li class="lb1" v-for="(item,index) in newList" :key="index">
                                  <div class="img-box" v-if="$route.params.key !=='JobOffers' && $route.params.key !=='Announcement'">
                                    <span  v-if="item.Thumbnai === null"> <img src="../assets/images/news/default.jpg"/></span>
                                    <span  v-else>
                                      <img :src="item.Thumbnai" v-if="item.IsWeixin === true"/>
                                      <img :src="item.imgUrl" alt="" v-else>
                                    </span>
                                  </div>
                                  <div class="lbr lbr1" :class="$route.params.key === 'JobOffers' || $route.params.key ==='Announcement' ?'NoImages':''">
                                    <div class="top top1" v-if="item.IsWeixin"><a :href="item.URL" target="_blank">{{item.Title}}</a></div>
                                    <div class="top top1" v-else><a href="javascript:void(0);" @click="goDetail(item)">{{item.Title}}</a></div>
                                    <div class="mid mid1" v-if="item.ReleaseDate">{{item.ReleaseTime}}</div>
                                    <div class="mid mid1" v-else>{{item.DateTime}}</div>
                                    <div class="bot bot1">{{item.Summary}}</div>
                                  </div>
                                </li>
                            </ul>
                        </div>
                        <div class="pag-box">
                          <div class="block">
                            <span @click="jumpFirstPage" class="my-btnF">首页</span>
                            <el-pagination
                              background
                              ref="pagination"
                              @size-change="handleSizeChange"
                              @current-change="handleCurrentChange"
                              :current-page.sync="currentPage"
                              :page-size="this.pageSize"
                              layout="total, prev, pager, next"
                              prev-text="上一页"
                              next-text="下一页"
                              :total="this.total">
                            </el-pagination>
                            <span @click="jumpLastPage" class="my-btnM">末页</span>
                          </div>
                          <!--移动端-->
                          <div v-show="!loading && newList.length < total" class="addMore" @click="addmore">加载更多</div>
                        </div>
                    </div>
                </div>
                <div class="box" v-loading="loading" v-show="$route.params.key === 'NewsVideo'">
                  <div class="content">
                    <div class="liebiao">
                      <div class="videoList" >
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-xs-12 playVideo" v-for="item in newList">
                            <div class="videoImg">
                              <a class="btnVideo" @click="goDetail(item)"></a>
                              <img :src="item.Thumbnai" v-if="item.IsWeixin === true"/>
                              <img :src="item.imgUrl" alt="" v-else>
                            </div>
                            <div class="vidoContent">
                              <div class="videoTitle">{{item.Title}}</div>
                              <div class="videoDate">
                                <span v-if="item.ReleaseDate">日期：{{item.ReleaseTime}}</span>
                                <span v-else>日期：{{item.DateTime}}</span>
                                <!--<span>播放量：2000</span>-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pag-box">
                      <div class="block">
                        <span @click="jumpFirstPage" class="my-btnF">首页</span>
                        <el-pagination
                          background
                          ref="pagination"
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="currentPage"
                          :page-size="this.pageSize"
                          layout="total, prev, pager, next"
                          prev-text="上一页"
                          next-text="下一页"
                          :total="this.total">
                        </el-pagination>
                        <span @click="jumpLastPage" class="my-btnM">末页</span>
                      </div>
                      <!--移动端-->
                      <div class="addMore" @click="addmore">加载更多</div>
                    </div>

                  </div>
                </div>
                <div class="box" v-loading="loading" v-show="$route.params.key === 'development' || $route.params.key === 'responsibility'">
                  <div class="content companyTitle">
                    <div class="fazhan_tp">
                      <div class="fazhan_liebiao">
                        <ul style="background-color: #985f0d">
                          <li class="fazhan_mm" :class="num===index?'active':''" @click="changeYear(item,index)" v-for="(item,index) in NewsList" :key="index">{{item.Title}}</li>
                        </ul>
                      </div>
                    </div>
                    <div class="fazhan_tptwo">
                      <div class="fazhan_liebiaoTwo">
                        <div class="fazhan_mmTwo" :class="num===index?'activeTwo':''" @click="changeYear(item,index)" v-for="(item,index) in NewsList" :key="index">{{item.Title}}</div>
                      </div>
                    </div>
                    <div class="delpcon html-wrap">
                      <div v-html="timeList.HtmlContent"></div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as utils from '../utils.js'
import * as api from '../api/api.js'
import SecCarousel from './secCarousel'
import md5 from 'js-md5'
export default {
  components: {
    SecCarousel
  },
  data () {
    return {
      name: '',
      fname: '',
      subMenu: [],
      curMenu: '',
      firMenu: '',
      htmlCont: '',
      loading: false,
      newList: [],
      imgUrl: 'http://service.jinlingholdings.com/Api/File/getImage/',
      num:0,
      currentPage:1,
      pageSize:10,
      total:0,
      timeList: [],
      curYear: '',
      curData: [],
      NewsList:[]
    }
  },
  watch: {
    '$route': function (val) {
      this.init()
    }
  },
  created () {
    this.init ()

  },
  methods: {
    jumpFirstPage(){
      this.$refs.pagination.handleCurrentChange(1);
      this.$emit('handleCurrentChange', 1);
    },
    jumpLastPage(){
      let font = this.$refs.pagination
      let cpage = Math.ceil(font.total / font.pageSize);
      font.handleCurrentChange(cpage);
    },
    handleSizeChange(val){
      this.pageSize = val
      this.getContent()
    },
    handleCurrentChange(val){
      this.currentPage = val
      this.getContent()
    },
    // 返回首页
    returnBack(){
      this.$router.push({path: '/'})
    },
    init: function () {
      var storage = utils.storage.get('jinLin_menu')
      if (storage && storage.data) {
        storage.data.forEach((vv) => {
          if (vv.Key === this.$route.params.fkey) {
            this.fname = vv.Name
            var _this = this
            this.subMenu = vv.subMenu
            this.firMenu = vv
            vv.subMenu.forEach((ss) => {
              if (ss.Key === this.$route.params.key) {
                _this.name = ss.Name
                _this.curMenu = ss
              }
            })
          }
        })
      }
      this.getContent()
    },
    getContent: function (type) {
      let param = {
        igid: this.curMenu.Id,
        Page: this.currentPage,
        PageSize: this.pageSize
      }
      this.loading = true
      api.getNewsList(param).then((res) => {
        this.loading = false
        if (res.Status === 100) {
          res.Data.DataList.forEach((vv) => {
            if (vv.Thumbnai) {
              vv.imgUrl = this.imgUrl + vv.Thumbnai
            }
            if(vv.IsWeixin){
              vv.URL = JSON.parse(vv.HtmlContent).url
            }
            vv.DateTime = this.$moment(vv.CreateDt).format('LL')
            if(vv.ReleaseDate !== null || vv.ReleaseDate !== undefined || vv.ReleaseDate !==''){
              vv.ReleaseTime = this.$moment(vv.ReleaseDate).format('LL')
            }
          })
          if (type) {
            this.newList = this.newList.concat(res.Data.DataList)
          } else {
            this.newList = res.Data.DataList
          }
          this.total = res.Data.total
          if (this.$route.params.key === 'development' || this.$route.params.key === 'responsibility') {
            this.NewsList = res.Data.DataList
            this.getFirst()
          }
        }
      })
    },
    addmore () {
      if (this.pageSize * this.currentPage < this.total) {
        this.currentPage = this.currentPage + 1
        this.getContent('addMore')
      }
    },
    getFirst(){
      this.timeList = this.NewsList[this.num]
    },
    handleData: function () {
      var yearList = []
      this.newList.forEach((vv) => {
        let year = parseInt(vv.Title.split('年')[0])
        vv.year = year
        if (yearList.indexOf(year) < 0) {
          yearList.push(year)
        }
      })
      yearList.sort(function(a,b){
        return a - b;
      })
      this.curYear = yearList[0]
      let diff = Math.ceil((yearList[yearList.length - 1] - yearList[0]) / 5)
      for(let i = 1; i <= diff; i++) {
        let param = {
          start: (yearList[0] + 5 * (i - 1)),
          end: (yearList[0] + 5 * i),
          data: []
        }
        this.timeList.push(param)
        // console.log(this.timeList)
      }
      this.timeList.forEach((vv) => {
        this.newList.forEach((ll) => {
          if ((ll.year < vv.end || ll.year === vv.end) && (ll.year > vv.start || ll.year === vv.start)) {
            vv.data.push(ll)
          }
        })
      })
      this.curData = this.timeList[0].data
    },
    changeYear (item,index) {
      this.num = index
      this.timeList = this.NewsList[index]
    },
    getBtn: function (item,index) {
      if(this.$route.params.key !==item.Key){
        if(item.Key ==='Onlineschool'){
          window.open('http://e-learning.jinlinghotels.com:8092',"_blank")
        }else {
          this.$router.push({name: 'news', params: {fkey: this.$route.params.fkey, key: item.Key}})
          this.total = 0
          this.currentPage = 1
          this.pageSize = 10
        }
      }
      if (!item.isList) {
        this.$router.push({name: 'info', params: {fkey: this.$route.params.fkey, key: item.Key}})
      }
    },
    goDetail: function (item) {
      const { href } = this.$router.resolve({name: 'newsDetail', params: {fkey: this.$route.params.fkey, key: this.$route.params.key, newsId: item.Id}});
      window.open(href);
    }
  }
}
</script>

<style>
  /* @import url("../assets/NewsList.css"); */
  .img-box{
    height: 150px;
    width: 240px;
    float: left;
    margin:0!important;
  }
  .img-box img{
    width: 100%;
    height: 150px;
    object-fit: cover;
  }
  .liebiao {
      display: block;
  }
  .fazhan_liebiao ul li{
    height: 40px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue